/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
enum KPISelection {
  RETAILER_KPI = 'Retailer Metric',
  OWN_KPI = 'Own Metric'
}

export default KPISelection;
